import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Reads the public requests feature config so customer-facing entry points
 * ("Ask retailers" / "Send request") can be hidden when the admin master
 * switch is OFF. Fails closed (enabled=false) on any error.
 */
export default function useRequestsConfig() {
  const [cfg, setCfg] = useState({ enabled: false, configured: false, loading: true });

  useEffect(() => {
    let alive = true;
    api
      .get("/requests/config")
      .then((r) => {
        if (!alive) return;
        setCfg({
          enabled: Boolean(r.data?.retailer_requests_enabled),
          configured: Boolean(r.data?.configured),
          loading: false,
        });
      })
      .catch(() => {
        if (alive) setCfg({ enabled: false, configured: false, loading: false });
      });
    return () => {
      alive = false;
    };
  }, []);

  return cfg;
}
